/*
**  WFMT Dynamic Loading Code
**	by Nate Beversluis, 2020 - 2021
**
*/

import { waitForGoogleTag, forceAd } from './google-tag';
import { checkForLiveYouTube } from './youtube-live';
import { UpdateWhatsOnNow, continuouslyRefreshSchedule } from './won';
import { resetDisqus } from './disqus';
import { setupSearchBar } from './google-search'
import { parseURL, decodeHtml, getAnchoredElement } from './utils'
import { setupMobileMenu, emulateMenuHighlights } from './pro'

/*
** Define sitePersistentPlayer as global variable, but we wait until the whole
** page is loaded before instantiating the player (below).
*/

window.sitePersistentPlayer = null;

// globals required by the MEJS media player
var _wpmejsSettings = {"pluginPath":"\/wp-includes\/js\/mediaelement\/","classPrefix":"mejs-","stretching":"responsive"};

//var mejsL10n = {"language":"en","strings":{"mejs.install-flash":"You are using a browser that does not have Flash player enabled or installed. Please turn on your Flash player plugin or download the latest version from https:\/\/get.adobe.com\/flashplayer\/","mejs.fullscreen-off":"Turn off Fullscreen","mejs.fullscreen-on":"Go Fullscreen","mejs.download-video":"Download Video","mejs.fullscreen":"Fullscreen","mejs.time-jump-forward":["Jump forward 1 second","Jump forward %1 seconds"],"mejs.loop":"Toggle Loop","mejs.play":"Play","mejs.pause":"Pause","mejs.close":"Close","mejs.time-slider":"Time Slider","mejs.time-help-text":"Use Left\/Right Arrow keys to advance one second, Up\/Down arrows to advance ten seconds.","mejs.time-skip-back":["Skip back 1 second","Skip back %1 seconds"],"mejs.captions-subtitles":"Captions\/Subtitles","mejs.captions-chapters":"Chapters","mejs.none":"None","mejs.mute-toggle":"Mute Toggle","mejs.volume-help-text":"Use Up\/Down Arrow keys to increase or decrease volume.","mejs.unmute":"Unmute","mejs.mute":"Mute","mejs.volume-slider":"Volume Slider","mejs.video-player":"Video Player","mejs.audio-player":"Audio Player","mejs.ad-skip":"Skip ad","mejs.ad-skip-info":["Skip in 1 second","Skip in %1 seconds"],"mejs.source-chooser":"Source Chooser","mejs.stop":"Stop","mejs.speed-rate":"Speed Rate","mejs.live-broadcast":"Live Broadcast","mejs.afrikaans":"Afrikaans","mejs.albanian":"Albanian","mejs.arabic":"Arabic","mejs.belarusian":"Belarusian","mejs.bulgarian":"Bulgarian","mejs.catalan":"Catalan","mejs.chinese":"Chinese","mejs.chinese-simplified":"Chinese (Simplified)","mejs.chinese-traditional":"Chinese (Traditional)","mejs.croatian":"Croatian","mejs.czech":"Czech","mejs.danish":"Danish","mejs.dutch":"Dutch","mejs.english":"English","mejs.estonian":"Estonian","mejs.filipino":"Filipino","mejs.finnish":"Finnish","mejs.french":"French","mejs.galician":"Galician","mejs.german":"German","mejs.greek":"Greek","mejs.haitian-creole":"Haitian Creole","mejs.hebrew":"Hebrew","mejs.hindi":"Hindi","mejs.hungarian":"Hungarian","mejs.icelandic":"Icelandic","mejs.indonesian":"Indonesian","mejs.irish":"Irish","mejs.italian":"Italian","mejs.japanese":"Japanese","mejs.korean":"Korean","mejs.latvian":"Latvian","mejs.lithuanian":"Lithuanian","mejs.macedonian":"Macedonian","mejs.malay":"Malay","mejs.maltese":"Maltese","mejs.norwegian":"Norwegian","mejs.persian":"Persian","mejs.polish":"Polish","mejs.portuguese":"Portuguese","mejs.romanian":"Romanian","mejs.russian":"Russian","mejs.serbian":"Serbian","mejs.slovak":"Slovak","mejs.slovenian":"Slovenian","mejs.spanish":"Spanish","mejs.swahili":"Swahili","mejs.swedish":"Swedish","mejs.tagalog":"Tagalog","mejs.thai":"Thai","mejs.turkish":"Turkish","mejs.ukrainian":"Ukrainian","mejs.vietnamese":"Vietnamese","mejs.welsh":"Welsh","mejs.yiddish":"Yiddish"}};
var scheduleUpdate = null;

jQuery(document).ready( function() {

	var siteURL = top.location.host.toString(),
		scheduleUpdate = null,
		checkYouTube = null,
		landingPage = parseURL(window.location.href).pathname,
		loadedPages = {},
		whatsOnNowTicker = null,
		currentURL = landingPage,
		urlParams = parseURL(window.location.href).search;

	/*
	** URLs containing any of these strings will be removed from dynamic updating.
	** Append/modify as needed.
	*/

	const exclusions = [
		'/wp-admin',
		'mailto:',
		'math-in-music',
		'/global/stream/',
		'.pdf',
		'/about-us/employment',
		'/your-front-row-seat',
		'/schedule-wfmt-app',
	];

	/*
	** This array keeps the site running on local and development environments
	*/

	const sameDomain = [
	 	'localhost',
	 	'www.wfmt.com',
		siteURL,
		siteURL.replace('pantheonsite','pantheon'),
		,];

	/*
	** Simulate back button functionality by preventing default behavior
	** and keeping track of navigation history.
	*/

	window.onpopstate = function (event) {

		if (! event.state ) {  return }

		if ( event.state.prevURL.includes('?s=') ) {

			var searchTerm = event.state.prevURL.split('?s=')[1];
			SearchGoogle(searchTerm, true);

		} else  {
			loadPage({
				URL : event.state.prevURL,
				backButton: true
			});
        }
    };

	/**********************************************************************************************
	** On initial landing, perform some setup:
	*/

	/*
	** Rewrite mobile menu links to be dynamic (only has to be done once)
	*/
	reWriteLinks(jQuery('.x-menu-collapsed a'));

	/* Any time new posts are loaded via Mailinky AJAX pagination,
	** rewrite the new links therein (see https://github.com/malinky/malinky-ajax-pagination)
	*/

	document.addEventListener('malinkyLoadPostsComplete', function(e) {
		reWriteLinks(jQuery('header').next().find('a'));
	});

	// Customize the Pro Mobile menu to be responsive dynamically
	// (see function definition in this file for info)
	setupMobileMenu();

	// Setup the Google Search Bar
	// (see function definition in ./google-search.js)
	setupSearchBar();

	// See function definition in ./google-tag.js
	waitForGoogleTag();

	// Instantiate site Persistent Player to the global variable declared earlier
	// Disable persistent player if its the schedule page for the app - it causes hanging loading issues.

	if ( currentURL != '/schedule-wfmt-app') {
	sitePersistentPlayer = new PersistentPlayer();
		// Set up a ticker to check every 10 seconds whether live stream player is playing,
		// if not, update "What's On Now" in the header.
		whatsOnNowTicker = setInterval( () => {
			if ( sitePersistentPlayer.mode != 'livestream' ) { UpdateWhatsOnNow(); }
			}, 10000);
	}

	/*
	**	Rewrite all <a> tags on the Header and Footer.
	** (This only needs to be done once.)
	**/
	var headerFooterLinks = jQuery('header a, footer a');
	reWriteLinks(headerFooterLinks);

	/*********************************************************************************************
	 * The rest of these have to be (and are) done on every refresh of the
	 * main container ; we call them once manually here when the user initially
	 * lands on the site.
	 */


	/* This actives the functinoality for the Malinky "Load More" button.
	** The manual .setUp() method is provided by the development.
	** See https://github.com/malinky/malinky-ajax-pagination.
	*/
	MalinkyAjaxPaging.setUp();

	/*
	*   Add shading in the site navigation bar depending on navigation path.
	*	This function is defined in pro.js.
	*/
	emulateMenuHighlights(landingPage);

	/*
	* The handlePage() method is defined later in this file and does
	* a number of things that have to be done every time content changes,
	* including on initial landing.
	*
	* Note, among other things, that this calls rewriteLinks(), which
	* ends up recursively callling all other needed functionality whenever
	* the navigation path changes.
	*/
	handlePage(landingPage+urlParams, null);


	/*

	The rest of the file contains function definitions.

	*/

	function loadPage(params) {

		/**  Main function to retrieve the content for a single page.
		 *  Accepts a single `params` object with attributes:
		 * 	URL (str), anchorID(str), queryString (str), backButton (boolean)
		 *
		 *  This function then calls loadPageContent(), which is what does
		 *  the actual working of loading the content into the DOM.
		 */

		var URL = parseURL(params.URL).pathname;
		var anchorID = params.anchorID || parseURL(URL).hash;
		var queryString = params.queryString || '';
		var backButton = params.backButton || false;

		emulateMenuHighlights(URL);

		if (URL in loadedPages) {
			/*
			** If the page has already been loaded, load it from memory
			*/
			if ( ! backButton ) {
				addtoState(URL + anchorID + queryString);}
				loadPageContent({
					result : loadedPages[URL],
					URL: URL,
					anchorID : anchorID
			});


		} else {
			/*
			** Otherwise, fetch it from the custom API endpoint
			*/

			fetch('/wp-json/custom/v2/url?url='+URL)
			.then(  function (response) {
				return response.json();
			})
			.then( function (result) {
				loadedPages[URL] = result;

				// handle 301
				if (result.permalink) {
					return loadPage({
						URL:result.permalink,
						anchorID : anchorID,
						queryString: queryString,
					})
				}
				if ( ! backButton ) {
					addtoState(URL + anchorID + queryString);
				}

				loadPageContent({
					result:result,
					URL :URL,
					anchorID : anchorID});
			});
		}
	}


	function loadPageContent(params) {

		/*
		Render retrieved content into the main container
		*/

		var result = params.result;
		var URL = params.URL;
		var anchorID = params.anchorID || '';
		var newContent = jQuery('<div />').html(result.content.rendered);

		/*
		*
		*  Remove the main container contents and replace it with the new contents.
		*  Note that many pages contain googletags that cause the script to halt if the
		*  user has an ad blocker. The `try/catch` logic permits this to continue.
		*
		*  Note that in either case, we next call handlePage() before continuing.
		*/

		try {
			jQuery('header').next().remove();
			jQuery(newContent).insertAfter('header').append(  () => {

				// Handle the new page content
				handlePage(URL, result);
				}
			);
		} catch (err) {
			console.log(err);

			// Handle the new page content
			handlePage(URL, result);
		}

		/*
			The API endpoint returns some CSS classes that need
			to be added to the <body> tag. Existing classes can
			always be safely removed.
		*/

		jQuery('body').removeClass();
		jQuery('body').addClass(result.body_classes);

		/*
		*	Add this page's X-generated CSS to the current view
		* 	(CSS generated by the theme stack)
		*/
		var newCSS = jQuery("<style type='text/css'/>").text(result.x_generated_css);
		newCSS.attr('id','x-generated-css');
		jQuery('head').append(newCSS);

		var cornerstoneCustomCSS = jQuery('<style type="text/css" />').text(result.cornerstone_custom_css);
		jQuery('#cornerstone-custom-page-css').remove();

		cornerstoneCustomCSS.attr('id','cornerstone-custom-page-css');
		jQuery('head').append(cornerstoneCustomCSS);

		/*
			Add any custom cornerstone scripts return by the API:
		*/

		if ( result.scripts && result.scripts != undefined ) {
			var script   = document.createElement("script");
			script.type  = "text/javascript";
			script.text  = result.scripts;
			jQuery('footer').append(script);
		}

		/*
		*	If the destination link includes an anchor ID,
		*	and the ID exists on the page, scroll to it
		*/
		if ( anchorID ) {

			var destinationElement = getAnchoredElement(anchorID);
			if (destinationElement.length) {
				var position = destinationElement.offset().top;
				window.scrollTo(0, position - 100);
			}

		} else if ( jQuery(document).scrollTop() > 180 ) {
			window.scrollTo(0, 0);
		}

		/*
		*	Update the page title in the browser tab.
		*	decodeHtml is defined in utils.js.
		*/
		document.title = decodeHtml(result.title);
	}


	function forceAd(slot) {

		/*
			Force every ad container to contain an ad.
			This is necessary because, due to the low volume of ad
			choices on this site, DFP sometimes returns blanks.
		*/

		var elID = slot.getSlotElementId();
		if ( elID == 'ad_pos_wfmt_homepage_leaderboard_upper_728x90') {return }
		if ( elID == 'ad_pos_wfmt_homepage_leaderboard_upper_300x100') {return }

		jQuery('#'+elID).each( function() {

			var style = jQuery(this).attr('style');
			var iframe = jQuery(this).has('iframe');

			if ( ( style && style.includes('display: none') )
				|| jQuery(this).has('iframe').length == 0
				) {
					googletag.pubads().refresh([slot]);
				}
		});
	}


	function handlePage(URL, result, isLandingPage=false) {

		/*
		Performs a number of operations that have to be
		done whenever the page content changes.
		*/

		/*
		Attempt to fill all the ad slots. If the user has an
		ad blocker, this will fail.
		*/
		try {
			if (WFMTslots != undefined) {
				WFMTslots.forEach( function(slot) {
					forceAd(slot);
				});
			}
		} catch (err) { console.log(err); }


		/*
		*	Remove or replace the leaderboard ad
		*/

		if ( URL == '/' ) {
			jQuery('.x-bar.wfmt-leaderboard-ad-desktop, .x-bar.wfmt-leaderboard-ad-desktop > div').css('display','flex'); // 728 x 90 ad
			jQuery('.wfmt-leaderboard-ad-mobile, .wfmt-leaderboard-ad-mobile > div').css('display','flex'); // 300 x 100 ad
		} else {
			jQuery('.wfmt-leaderboard-ad-desktop, .wfmt-leaderboard-ad-desktop > div').css('display','none'); // 728 x 90 ad
			jQuery('.wfmt-leaderboard-ad-mobile, .wfmt-leaderboard-ad-mobile > div').css('display','none'); // 300 x 100 ad
		}

		/*
		* If we are on the home page, set up a listener for YouTube Livestreams
		*/

		if ( URL == '/' ) {
			checkForLiveYouTube();
		} else { clearTimeout(checkYouTube); }

		/*
		* Hide or show the "what's on now" metadata topper,
		* depending where we are on the site and what mode of player is playing.
		*/
		if ( 	URL == '/'
			&& 	( 	sitePersistentPlayer == null
				|| sitePersistentPlayer.mode != 'livestream' )
			) {

			jQuery('.metadata-block-mobile, .metadata-block-mobile > div').css('display','flex'); // mobile only
			jQuery('.x-bar.metadata-block-desktop').css('display','none'); // hide desktop

		} else if (
				URL != '/'
			&& 	( 	sitePersistentPlayer == null
				||  sitePersistentPlayer.mode != 'livestream' )
				) {

			// if NOT on the home page and player either not playing or is playing something other than livestream:
			jQuery('.metadata-block-mobile, .metadata-block-mobile > div, .metadata-block-desktop, .metadata-block-desktop > div')
			.css('display','flex');

		} else if (sitePersistentPlayer != null ) {

			// Otherwise: Anywhere and livestream is playing.
			jQuery('.metadata-block-mobile, .metadata-block-mobile > div, .x-bar.metadata-block-desktop')
				.css('display','none');

		}

		//  WordPress Popular Posts plugin uses the attribute "data-img-src"
		//  which does not dynamically load the images. Add an img attribute with the same value.

		jQuery('img.wpp-thumbnail').each(function() {
		  var $t = jQuery(this);
		  $t.attr({
		      src: $t.attr('data-img-src'),
		    });
		});

		/*
			If this is not the page the visitor landed on
			(i.e. this page was loaded in dynamically),
			we need to do a number of other things:
		*/

		if ( ! isLandingPage) {

			// Emulate the menu effect again after the changes
			emulateMenuHighlights(URL);

			// DISQUS must be manually refreshed
			var disqusContainer = jQuery('#disqus_thread')
			if (disqusContainer.length) {
				var pageURL = jQuery('.x-container.main').attr('wfmt_disqus_pageurl')
				var disqusID = jQuery('.x-container.main').attr('wfmt_disqus_id')
				resetDisqus(disqusID, pageURL);
			}

			// Manually load the Ninja Form, if found
			loadNinjaForms();

			// clear the schedule update timer if this is another page
			clearInterval(scheduleUpdate);
		}

		/*
		* If this is the schedule page, set a timer to refresh the  schedule dynamically
		*/

		if (URL.includes('schedule') && ! URL.includes('pldate') ) {
			scheduleUpdate = continuouslyRefreshSchedule();
		}


		/*
			Rewrite all <a> tags again to cause this whole procedure
			to run again on any new click.
		*/
		reWriteLinks(jQuery('header').next().find('a'));

		/*
		* Push Google Analytics
		*/

	    if (! result) {
	    	var category = jQuery('.x-container.main').attr('wfmt_category');
	    	var pageAttr = jQuery('.x-container.main').attr('wfmt_tag');
	    	var author = jQuery('.x-container.main').attr('wfmt_author');

	    } else {
	    	var category = result['category'];
			var pageAttr = result['tags_list'];
			var author = result['author'];
	    }

		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push({
			'event': 'pageviewCustomEvent',
			'pagePath': URL,
			'pageTitle': document.title,
			'pageCategory':category,
			'pageAttributes': pageAttr,
			'pagePostAuthor': author,
		});


	}


	function loadNinjaForms() {

		/*
		This will dynamically load in the scripts, form, and template
		for a Ninja form. It is dependent on `NinjaFormsAsyncForm`
		which is defined in /pro/js/ninjs-forms-async.js
		and is enqueued site-wide in functinos.php.
		*/

		var forms = jQuery('.nf-form-cont');

		if  (forms.length > 0 ) {
			var formID = forms[0].getAttribute('id')
				.replace('nf-form-','')
				.replace('-cont','');

			var ninjaID = parseInt(formID)
			var asyncForm = new NinjaFormsAsyncForm(ninjaID, '.nf-form-cont');
			asyncForm.fetch( () => {
				asyncForm.load();
			});
		}

	}


	function addClickListener(element) {

		/*
		Simple function to prevent default behavior on an <a> tag
		and call 'loadPage()' instead.
		*/

		element.unbind(); // avoid accidentally adding more than one listener
		element.click( function (e) {
				e.preventDefault();
				var el = jQuery(this);
				loadPage({URL: el.attr("href")});
			});
		}


	function reWriteLinks(linkList, URL) {

		/*
		Main function to rewrite all the links in a container to work dynamically.
		Many conditionals are necessary here to handle particular cases.
		*/

		linkList.each( (el) => {

			var element = jQuery(linkList[el]);

			/*
				We provide a`do-not-rewrite` class which can be applied to
				any element.
			*/
			if ( element.hasClass("do-not-rewrite"))  {return };

			/*
				If the link contains the string `?pldate`, we are on the
				schedule page. This provides some logic
				that makes the sidebar schedule calendar work dynamically.
			*/

			if ( element.attr("href") && element.attr("href").includes('?pldate') ) {
				var queryString = element.attr("href");
				element.attr("href", queryString);
				element.addClass("internal-link");
				element.addClass("schedule-page-calendar");
				element.click( function(event) {
					event.preventDefault();
					clearInterval(scheduleUpdate);
					loadPage({
						URL: '/schedule/'+queryString.replace('?','&'),
					});
				});
				return
			}


			/*
				For all other links, we parse out a few
				components to evaluate individually.
				pathname, role, queryString.
			*/
			var y = parseURL(linkList[el].href);
			var pathname = y.pathname;
			var role = element.attr("role") || '';

			var queryString = ''
			if (y.searchObject) {
				queryString = '?';
				Object.keys(y.searchObject).forEach( (key) => {
					queryString += key + '=' + y.searchObject[key] + '&';
				});
				queryString = queryString.slice(0, -1);
			}

			/*
			*  If the link is in the exclusions list defined above,
			*  force it to open in a new page.
			*/
			for (var i=0; i < exclusions.length; i++) {
				if ( pathname && pathname.includes(exclusions[i]) ) {
					element.attr("target","_blank");
					return
				}
			}

			/*
				Don't rewrite the Malinky Ajax Pagination button.
				This will cause problems.
			*/
			if ( element.attr('id') == 'malinky-ajax-pagination-button' ) {
				return
			}
			/*
				Don't rewrite the mute-toggle button.
			*/

			if ( element.attr('id') == 'mute-toggle' ) {
				return
			}

			/*
				If the link is inside content handle by the the Malinky Ajax Load More button,
				some special logic is needed:
			*/

			if ( element.attr('class') && element.attr('class').includes('page-numbers')) {

				// Strip off query strings inside links retrieved from the API feed,
				// as this creates an issue with Malinky Load More button.
				var existingHref = element.attr("href");
				existingHref = existingHref.split('?')[0];

				// Manually rewrite pager links to the current path,
				// since this does not always happen automatically.«
				var currentPath = parseURL(window.location.href).pathname;
				if ( currentPath[currentPath.length-1] != '\/' ) {
						currentPath += '\/'
				}

				var pageSuffix = existingHref.split('page')[1];
				var newHref = currentPath + 'page' + pageSuffix;
				element.attr("href", newHref);
				return;
			}

			/*
				The tab feature in the Programs pages
				uses <a> tags for the tab. We do not rewrite these.
			*/
			if ( role == 'tab') { return }


			/*
				Ignore these also -- added by some plugins.
			*/
			if ( element.attr('data-pin-do') == 'embedPin' ) { return }


			/*
				If the domain is not the current one,
				rewrite the link to open in a new page
			*/

			if ( ! sameDomain.includes(y.hostname) ) {
				// external link
				element.addClass("external-link");
				element.attr("target","_blank");
				return;
			}

			/*
			*
			* If the link contains a page anchor, we need to determine whether it is
			* on this page or another page on the site, and scroll or reload accordingly.
			*/
			if (y.hash && parseURL(window.location.hef)) {

				// anchor is internal, but on another page
				element.addClass("anchor-link-other-page");
				element.attr("wfmt-anchor-to", y.hash);
				element.attr("href", pathname + y.hash + queryString);
				element.click( function(event) {
					event.preventDefault();
					loadPage({
						URL: pathname,
						anchorID: y.hash,
						queryString: queryString
					});
				});
				return;

			// otherwise the anchor is on this page ( but continue only if anchor is defined )
			} else if (y.hash ) {

				// allow both ID and `name` attribute as anchors
				var destinationElement = getAnchoredElement(y.hash);

				if ( destinationElement.length > 0 ) {

					//	assign same-page anchors a "scroll to location"
					element.addClass("anchor-link-same-page");
					var position = destinationElement.offset().top;
					jQuery(element)[0].removeEventListener('click'); // prevent duplicate events
					jQuery(element)[0].addEventListener('click', function(event) {
						event.preventDefault();
						event.stopPropagation();
						window.scrollTo(0, position - 100);
					});

				}
				return;
			}

			/*
			*
			* Treat all other links except programs "tabs" as internal links without anchors
			* (This ends up being what happens to most links -- they are not caught by exceptions above.)
			*/

			if (pathname) {
				element.addClass("internal-link");
				element.attr("href", pathname);
				element.attr("data-cturl", pathname);
				element.removeAttr("target"); // this is only for GCSE results. May not be needed on all.
				addClickListener(element);
			}

		});

		// must be done on every main container refresh:
		MalinkyAjaxPaging.setUp();
		setupLiveStreamTrigger();

	}

	function setupLiveStreamTrigger() {

		/*
		If they are any livestream "play" buttons on the page, set these up to trigger
		the player.
		*/
		jQuery('.live-stream-trigger').each ( function () {

			// This makes sure each button only gets one listener.
			// https://stackoverflow.com/questions/11455515/how-to-check-whether-dynamically-attached-event-listener-exists-or-not
			if ( this.getAttribute('livestreamtrigger') !== 'true' )  {
				this.addEventListener('click', function(event){
	  	          	sitePersistentPlayer.PlayLiveStream();
				});
	          	this.setAttribute('livestreamtrigger', 'true');
			}
		});
	}

	function addtoState(url) {
		/*
		* Add a URL to the browser history.
		*/
		window.history.pushState({'prevURL': currentURL}, null, url);
		currentURL = url;
	}

});
